
const nullPromocodeValueToString = (promocode) => promocode ?? '';

export const promocodeField = {
    read(_promocode) {
        return nullPromocodeValueToString(_promocode);
    },
};
